import { Shield, Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface ShieldCreditsCounterProps {
  credits: number;
  isLoading?: boolean;
  isCollapsed?: boolean;
  isPaidUser?: boolean;
}

const ShieldCreditsCounter = ({ 
  credits, 
  isLoading = false,
  isCollapsed = false,
  isPaidUser = false,
}: ShieldCreditsCounterProps) => {
  if (isCollapsed) {
    return (
      <div className="flex flex-col items-center gap-1 py-2">
        <div className={cn(
          "p-2 rounded-lg bg-cyan/10 border border-cyan/20"
        )}>
          {isLoading ? (
            <Loader2 className="w-4 h-4 animate-spin text-muted-foreground" />
          ) : (
            <Shield className="w-4 h-4 text-cyan" />
          )}
        </div>
        {!isLoading && (
          <span className="text-xs font-bold text-cyan">{credits}</span>
        )}
      </div>
    );
  }

  return (
    <div className={cn(
      "p-3 rounded-xl border bg-charcoal-medium border-glass-border"
    )}>
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-cyan/10">
          {isLoading ? (
            <Loader2 className="w-5 h-5 animate-spin text-muted-foreground" />
          ) : (
            <Shield className="w-5 h-5 text-cyan" />
          )}
        </div>
        
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">Rehearsal Credits</p>
          <p className="text-xs text-muted-foreground">
            {isLoading ? "Loading..." : `${credits} sessions available`}
          </p>
        </div>

        {!isLoading && (
          <div className="text-2xl font-bold text-cyan tabular-nums">
            {credits}
          </div>
        )}
      </div>
    </div>
  );
};

export default ShieldCreditsCounter;
